import React from 'react';
import { freshnessBadge } from '../utils/processorFreshness';
import {
  processorDirectionsUrl,
  processorSourceLabel,
  processorTelHref,
} from '../utils/processorList';

export function ProcessorRow({ row, highlighted = false, onSelect }) {
  const badge = freshnessBadge(row.freshness);
  const yona = row.source === 'yona';
  const miles = Number.isFinite(row.miles) ? row.miles.toFixed(1) : '—';
  const drive = Number.isFinite(row.drive_minutes) ? `${row.drive_minutes} MIN DRIVE` : '';
  const phoneHref = processorTelHref(row.phone);

  return (
    <article
      className={`fap-row${highlighted ? ' is-on' : ''}`}
      data-testid={`processor-row-${row.id}`}
    >
      <button
        type="button"
        className={`fap-row__pin${yona ? ' fap-row__pin--yona' : ' fap-row__pin--place'}`}
        aria-label={row.name}
        onClick={() => onSelect?.(row.id)}
      >
        {yona ? '✦' : '·'}
      </button>

      <button
        type="button"
        className="fap-row__name"
        onClick={() => onSelect?.(row.id)}
      >
        <span className="fap-row__title">{row.name}</span>
        <span className="fap-row__meta">
          {row.town}
          {' · '}
          {processorSourceLabel(row)}
        </span>
      </button>

      <div className="fap-row__distance">
        <span className="fap-row__miles">
          {miles}
          <span className="fap-row__miles-unit">MI</span>
        </span>
        <span className="fap-row__drive">{drive}</span>
      </div>

      <div className="fap-row__fresh">
        <span className={`fap-badge fap-badge--${badge.tone}`}>{badge.label}</span>
      </div>

      <div className="fap-row__actions">
        <a className="fap-row__call" href={phoneHref} data-testid={`processor-call-${row.id}`}>
          CALL
        </a>
        <a
          className="fap-row__dir"
          href={processorDirectionsUrl(row)}
          target="_blank"
          rel="noreferrer"
          data-testid={`processor-directions-${row.id}`}
        >
          DIRECTIONS
        </a>
      </div>
    </article>
  );
}
